<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" :fill="outerColor" />
    <path d="M8 7h3v10H8V7zm5 0h3v10h-3V7z" :fill="innerColor" />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 28,
      required: false,
    },
    outerColor: {
      type: String,
      default: '#000000',
      required: false,
    },
    innerColor: {
      type: String,
      default: '#ffffff',
      required: false,
    },
  },
};
</script>

<style scoped></style>
